import React, { useCallback, useState, useRef, useEffect } from 'react';
import { View, FlatList, ScrollView, Image, TouchableOpacity, Text, Animated, StyleSheet } from 'react-native';
import * as FileSystem from 'expo-file-system';
import { DraggableScrollView } from '../DraggableScrollView.web';
import { emitEvent, addEventListener, removeAllEventListeners } from '@/services/EventService';
import { useBoundStore } from '@/services/zustand/Store';

import 'keen-slider/keen-slider.min.css';
import '@/components/styles/webKeenSlider.css';
import { useKeenSlider } from 'keen-slider/react';

const Arrow = (props: {
    disabled: boolean
    left?: boolean
    onClick: (e: any) => void
}) => {
    const disabled = props.disabled ? " arrow--disabled" : ""
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${
                props.left ? "arrow--left" : "arrow--right"
            } ${disabled}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
        {props.left && (
            <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        )}
        {!props.left && (
            <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        )}
        </svg>
    )
};

const SliderControlComponent = (props: {
    instanceRef: any,
    numPages: number,
}) => {

    const currentPage: number = useBoundStore(useCallback((state) => state.currentPage, []));
    

    return(
        <>
            <Arrow
                left
                onClick={(e: any) =>
                    e.stopPropagation() || props.instanceRef.current?.prev()
                }
                disabled={(currentPage - 1) === 0}
            />

            <Arrow
                onClick={(e: any) =>
                    e.stopPropagation() || props.instanceRef.current?.next()
                }
                
                disabled={
                    //currentSlide === instanceRef.current?.track.details.slides.length - 1
                    (currentPage - 1) === (props.numPages - 1)
                }
                //style={[styles.arrow]}
            />
        </>
        
    )

};


export const getPageImage = async (date: any, edition: any, pageNo: number, image: any) => {

    return new Promise(async (resolve, reject) => {

        const articleImageData: any = await fetch(
            '/web-server-api/getImage',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "type": 'pageImage',
                    "date": date,
                    "edition": edition,
                    "pageNo": pageNo,
                    "image": image
                }),
            }
        );
    
        const data = await articleImageData.json();
        const imageBase64 = data.base64ImageStr;

        if(imageBase64) {
            resolve({ uri: `${imageBase64}` });
        }
        else {
            reject(false);
        }
    });

    

};

export default function PageNavigation(props: {
    magazineDataForViewer: Array<{
        pageTitle: string,
        pageNumber: string,
        pdfFile: string
    }>
}) {

    const origin = window.location.origin;

    const currentMagazine = useBoundStore(useCallback((state) => state.magazine, []));
    const interstitialData = useBoundStore(useCallback((state) => state.interstitialData, []));
    const currentPage = useBoundStore(useCallback((state) => state.currentPage, []));
    //const updateCurrentPage = useBoundStore(useCallback((state) => state.updateCurrentPage, []));
    const numberOfPages = useBoundStore(useCallback((state) => state.numberOfPages, []));
    const [numPages, setNumPages] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const slideAnim = useRef(new Animated.Value(270)).current;
    
    const flatListRef = useRef<FlatList>(null);
    const scrollListRef = useRef<ScrollView>(null);

    const [sliderLoaded, setSliderLoaded] = useState(false);
    //const [currentSlide, setCurrentSlide] = useState(0);
    
    const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        //initial: useBoundStore.getState().currentPage,
        renderMode: 'performance',
        //mode: "free",
        slides: {
            //origin: 'auto',
            perView: 'auto',
            spacing: 10,
        },
        slideChanged(slider) {
            
        },
        created() {
            setSliderLoaded(true);

            setTimeout(() => {
                pageSelectionListener(useBoundStore.getState().currentPage);
            }, 200);
        },
        updated() {
            
        },
    });

    const [listItem, setListItem] = useState([]);
    const [isVisible, setIsVisible] = useState(false);

    const pageSelectionListener = (value: any) => {
        instanceRef.current?.moveToIdx((value - 1));
    };
    
    removeAllEventListeners('PageSelectionByViewer')
    addEventListener('PageSelectionByViewer', pageSelectionListener);


    const toggleModal = () => {
        if (!modalOpen) {
            setIsVisible(true);
            setModalOpen(true);
        }
        else {
            setIsVisible(false);
            setModalOpen(false);
        }
    }

    const listener = () => {
        if (modalOpen === true) {
            toggleModal()
        }
    };
    removeAllEventListeners('PageChange')
    addEventListener('PageChange', listener);

    const handleNavigationPress = (page: number) => {
        instanceRef.current?.moveToIdx((page - 1));
        emitEvent('PageSelectionByNavigation', page);
    }

    const renderContent = (item: any, index: number) => {

        return (
            <View>
                <TouchableOpacity onPress={() => handleNavigationPress(index + 1)} style={styles.pageButton}>
                    <Text 
                        style={{ 
                            color: '#000', 
                            alignSelf: 'center', 
                            fontSize: 10 
                        }}
                        >{item.titel}</Text>
                    
                    <Image style={{ maxWidth: 160, minWidth: 160, height: 220 }} source={item.image} />
                </TouchableOpacity>
            </View>
        )
    };

    const renderPageButton = ({ item, index }: { item: any, index: number }) => (
        <View>
            <TouchableOpacity onPress={() => handleNavigationPress(index + 1)} style={styles.pageButton}>
                <Text style={{ color: '#000', alignSelf: 'center', fontSize: 10 }}>{item.titel}</Text>
                <Image style={{ width: 160, height: 220 }} source={ item.image } />
            </TouchableOpacity>
        </View>
    );
    
    

    useEffect(() => {

        console.log('props.magazineDataForViewer', props.magazineDataForViewer);

        const buildList = async () => {

            let scrollViewItem: any = [];
            let add = 0;

            for (let i = 1; i <= numberOfPages; i++) {
                let titel: string = "";
                let image: any = "";
                if (interstitialData !== null) {
                    if (interstitialData[0].page < i) {
                        add = -1;
                    } else if (interstitialData[0].page > i) {
                        add = 0
                    }
                    if (interstitialData[0].page === i) {
        
                        image = `https://cdn.duden.de/lexem_images/204279.png`;
                        titel = "Anzeige";
                    } else {
                        //image = `${origin}/protected-files/${currentMagazine?.date}/${i + add}/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = `${origin}/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = `${origin}/${currentMagazine?.date}/${currentMagazine?.edition}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = `${FileSystem.documentDirectory}/epaper/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        image = await getPageImage(currentMagazine?.date, currentMagazine?.edition, i + add, `s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`);
                        //titel = `Seite: ${i + add}`;
                        titel = `${props.magazineDataForViewer[(i - 1) + add].pageTitle}`;
                    }
                }
                if (interstitialData == null) {
                    //image = `${origin}/protected-files/${currentMagazine?.date}/${i + add}/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                    //image = `${origin}/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                    //image = `${origin}/${currentMagazine?.date}/${currentMagazine?.edition}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                    //image = `${FileSystem.documentDirectory}/epaper/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                    image = await getPageImage(currentMagazine?.date, currentMagazine?.edition, i + add, `s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`);
                    //titel = `Seite: ${i + add}`;
                    titel = `${props.magazineDataForViewer[(i - 1) + add].pageTitle}`
                }
                scrollViewItem.push({ image, titel });

                if(i === numberOfPages) {
                    setNumPages(scrollViewItem.length);
                    setListItem(scrollViewItem);
                }
            }
        }
        buildList();

        
    }, [numberOfPages]);

    return (
        <View style={[styles.container]}>
            <View style={[styles.modalContent]}>
                <TouchableOpacity onPress={toggleModal} style={styles.openButton}>
                    <Text style={styles.textStyle}>Menü</Text>
                </TouchableOpacity>

                { isVisible && 

                    <View
                        style={{
                            flex: 1,
                            width: '100vw'
                        }}
                    >
                        <div ref={sliderRef} className="keen-slider">

                            {
                                listItem.map((item: any, index: number) => (
                                    <div
                                        key={`pageNavigation_slide_${index + 1}`} 
                                        className={`keen-slider__slide number-slide${index + 1}`}
                                        style={{ maxWidth: 160, minWidth: 160 }}
                                        onClick={() => handleNavigationPress(index + 1)}
                                    >
                                        {
                                            renderContent(item, index)
                                        }
                                        
                                    </div>
                                    
                                ))
                            }

                            {
                                /*
                                Array.from(
                                    new Array(numPages),
                                    (el, index) => (

                                        <div
                                            key={`pageNavigation_slide_${index + 1}`} 
                                            className={`keen-slider__slide number-slide${index + 1}`}
                                        >

                                        </div>
                                    )
                                )
                                */
                            }
                        </div>

                        {sliderLoaded && (
                            <>
                                <SliderControlComponent 
                                    instanceRef={ instanceRef }
                                    numPages={ numPages }
                                />
                            </>
                        )}
                    </View>
                }
                
            </View>
        </View>
    );

    return (
        <View style={[styles.container]}>
            <View style={[styles.modalContent]}>
                <TouchableOpacity onPress={toggleModal} style={styles.openButton}>
                    <Text style={styles.textStyle}>Menü</Text>
                </TouchableOpacity>

                { isVisible && 
                /*
                    <FlatList
                        ref={flatListRef}
                        data={listItem}
                        horizontal
                        keyExtractor={(item, index) => (index).toString()}
                        renderItem={renderPageButton}
                        showsHorizontalScrollIndicator={true}
                    />
                */

                    <View
                        style={{
                            flex: 1,
                            width: '100vw'
                        }}
                    >
                        <DraggableScrollView 
                            //ref={ scrollListRef }
                            nestedScrollEnabled={ true }
                            showsHorizontalScrollIndicator={ true }
                            //horizontal= { true }
                            //scrollEventThrottle={ 16 }

                            //onPointerDown={ handlePointerDown }
                            //onPointerLeave={ handlePointerLeave }
                            //onPointerUp={ handlePointerUp }
                            //onPointerMove={ handlePointerMove }
                            //onScroll={ handleScroll }
                            
                        >
                        {
                            
                            listItem.map((item: any, index: number) => (
                                renderContent(item, index)
                            ))
                            
                            
                        }
                        </DraggableScrollView>
                    </View>
                }
                
            </View>
        </View>
    );

/*
    return (
        <Animated.View style={[styles.container, { transform: [{ translateY: slideAnim }] }]}>
            <View style={[styles.modalContent]}>
                <TouchableOpacity onPress={toggleModal} style={styles.openButton}>
                    <Text style={styles.textStyle}>Menü</Text>
                </TouchableOpacity>
                <FlatList
                    ref={flatListRef}
                    data={listItem}
                    horizontal
                    keyExtractor={(item, index) => (index).toString()}
                    renderItem={renderPageButton}
                    showsHorizontalScrollIndicator={false}
                />
            </View>
        </Animated.View>
    );
*/
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        bottom: 0,
        alignItems: 'center',
        width: '100%',
        position: 'absolute',
    },
    openButton: {
        width: '100%',
        height: 45,
        padding: 3,
        backgroundColor: '#CCC',
    },
    modalContent: {
        flex: 1,
        bottom: 0,
        alignItems: 'center',
        width: '100%',
        height: 300,
        backgroundColor: '#fff',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
    },
    textStyle: {
        color: '#000',
        textAlign: 'center',
    },
    pageButton: {
        borderRadius: 5,
        margin: 4,
        padding: 2,
        backgroundColor: '#eee',
    },
});
